import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

/**
 * Formata datas da API, que chegam em UTC sem sufixo "Z" (ex.: "2026-10-12T15:40:00"),
 * convertendo para o horário local do navegador. Uso: {{ value | utcDate:'dd/MM/yyyy HH:mm' }}
 */
@Pipe({ name: 'utcDate', standalone: true })
export class UtcDatePipe implements PipeTransform {
  transform(value?: string | Date | null, format = 'dd/MM/yyyy HH:mm', empty = '—'): string {
    if (!value) return empty;
    const iso = typeof value === 'string' && !/[zZ]$|[+-]\d{2}:\d{2}$/.test(value) ? value + 'Z' : value;
    try {
      return formatDate(iso, format, 'pt-BR');
    } catch {
      return empty;
    }
  }
}

/** Mesma regra do pipe, para uso em código. */
export function parseUtc(value?: string | null): Date | null {
  if (!value) return null;
  const iso = !/[zZ]$|[+-]\d{2}:\d{2}$/.test(value) ? value + 'Z' : value;
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d;
}
